import React from 'react';
import { BrowserRouter } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export const RouterProvider = ({ children }: Props) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};
